import React from "react";
import { hexToRgba } from "@/lib/tags";
import { cn } from "@/lib/utils";

/**
 * Small tag pill. Passing `size="lg"` bumps typography for the profile header.
 */
const TagPill = ({ tag, size = "sm", className, testid }) => {
  if (!tag) return null;
  const styleObj = {
    background: hexToRgba(tag.color, 0.15),
    color: tag.color,
    border: `1px solid ${hexToRgba(tag.color, 0.35)}`,
  };
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-[4px] font-semibold",
        size === "lg"
          ? "px-2.5 py-1 text-[13px] tracking-[0.04em]"
          : "px-2 py-[2px] text-[11px] tracking-[0.04em]",
        className
      )}
      style={styleObj}
      data-testid={testid || `tag-pill-${tag.slug}`}
    >
      <span
        className="inline-block rounded-full"
        style={{
          width: size === "lg" ? 8 : 6,
          height: size === "lg" ? 8 : 6,
          background: tag.color,
        }}
      />
      {tag.name}
    </span>
  );
};

export default TagPill;
